/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { TimeFilter, PageType } from 'src/app/models/enums';
import { SportsService } from 'src/app/services/sports.service';
import { Subscription } from 'rxjs';
import { UtilityService } from 'src/app/services/util/utility.service';
import { UserService } from 'src/app/services/user.service';
import { EventsService } from 'src/app/services/events.service';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.less']
})
export class FilterComponent implements OnInit, OnDestroy {
  timeFilterValue: TimeFilter;
  timeFilterValueEnum = TimeFilter;
  eventsTimeLeagueFilter = false;
  eventsPopularNextFilter = true;
  public pageType: PageType;
  public pageTypeEnum = PageType;
  today: Date = new Date();
  D1: Date = new Date(this.today.getTime() + (24 * 60 * 60 * 1000));
  D2: Date = new Date(this.today.getTime() + (48 * 60 * 60 * 1000));
  D3: Date = new Date(this.today.getTime() + (72 * 60 * 60 * 1000));
  D4: Date = new Date(this.today.getTime() + (96 * 60 * 60 * 1000));
  D5: Date = new Date(this.today.getTime() + (120 * 60 * 60 * 1000));
  D6: Date = new Date(this.today.getTime() + (144 * 60 * 60 * 1000));
  public orderByCompetition = true;

  isMobileView: boolean;

  showSearchMobile = false;

  private subscription: Subscription = new Subscription();
  constructor(protected sportsService: SportsService, protected utilityService: UtilityService, protected userService: UserService, protected eventsService: EventsService, protected queryParamService: QueryParamsService) {
    // this.timeFilterChangedSubscription = sportsService.timeFilterChanged$.subscribe(x => this.timeFilterValue = x);
    this.isMobileView = utilityService.mobileView;
    this.pageType = queryParamService.pageType;
    this.subscription.add(this.queryParamService.pageTypeChanged$.subscribe((pt) => this.pageType = pt));
    this.subscription.add(this.eventsService.expandedEvent$.subscribe((ev) => this.showHideSearchMobile(false)));
    this.subscription.add(this.sportsService.openCompetitionFromBanner$.subscribe(() => this.timeFilterValueChange(TimeFilter.All, PageType.Prematch)));
  }

  ngOnInit(): void {
    this.timeFilterValue = this.sportsService.timeFilterValueGet;
  }

  toggleShowSearchMobile(): void {
    this.showSearchMobile = !this.showSearchMobile;
  }

  showHideSearchMobile(visible: boolean): void {
    this.showSearchMobile = visible;
  }

  timeFilterValueChange(timeFilterValue: TimeFilter, pageType?: PageType) {
    if (pageType && pageType !== this.pageType) {
      this.queryParamService.pageType = pageType;
    }

    if (this.timeFilterValue !== timeFilterValue) {
      if (this.timeFilterValue === TimeFilter.Live) {
        this.orderByCompetition = true;
      }
      this.eventsService.orderEventsByTime = !this.orderByCompetition;
      this.timeFilterValue = timeFilterValue;
      this.sportsService.changeTimeFilterValue(timeFilterValue, this.isMobileView);
    } else {
      if (this.isMobileView && timeFilterValue === TimeFilter.Live) {
        this.orderByCompetition = !this.orderByCompetition;
        // implement later
        this.eventsService.orderEventsByTime = !this.orderByCompetition;
      }
    }
  }

  eventsTimeLeagueFilterChange(val: boolean) {
    this.eventsTimeLeagueFilter = val;
  }

  eventsPopularNextFilterChange(val: boolean) {
    this.eventsPopularNextFilter = val;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
